import React, { useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { useCrypto } from './CryptoContext.tsx';

function PasswordUnlock() {
  const { status, error, unlockWithPassword } = useCrypto();
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [localError, setLocalError] = useState<string | null>(null);

  if (status !== 'locked') return null;

  const handleUnlock = async (event) => {
    event.preventDefault();
    setBusy(true);
    setLocalError(null);
    try {
      await unlockWithPassword(password);
      setPassword('');
    } catch (err) {
      setLocalError(err instanceof Error ? err.message : 'Unlock failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Alert variant="secondary" className="mb-3">
      <p className="mb-2">
        Enter your login password to unlock chat keys on this device.
      </p>
      <Form onSubmit={handleUnlock}>
        <Form.Group className="mb-2">
          <Form.Label visuallyHidden>Password</Form.Label>
          <Form.Control
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
          />
        </Form.Group>
        {(localError || error) && <p className="text-danger">{localError || error}</p>}
        <Button type="submit" variant="primary" disabled={busy || !password}>
          {busy ? 'Unlocking…' : 'Unlock'}
        </Button>
      </Form>
    </Alert>
  );
}

export default PasswordUnlock;
